import { render, staticRenderFns } from "./buy_success1.vue?vue&type=template&id=b5c221ec&scoped=true&"
import script from "./buy_success1.vue?vue&type=script&lang=js&"
export * from "./buy_success1.vue?vue&type=script&lang=js&"
import style0 from "./buy_success1.vue?vue&type=style&index=0&id=b5c221ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c221ec",
  null
  
)

export default component.exports